export default __webpack_public_path__ + "static/media/Graident 3.d2c64adc.png";